
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 21.6a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2zM11.466 8.6a1.2 1.2 0 00-1.866.998v4.8a1.2 1.2 0 001.866.999l3.6-2.4a1.2 1.2 0 000-1.997l-3.6-2.4z","fill":"#9B9FA9"}})])
          )
        }
      }
    